//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";
import Constants from "../../../../../config/Constants";

const EditService = {
    loadScreenView: (spelling, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/pinyin/edit/loadscreenview", { spelling }, successCallback, failureCallback);
    },
    savePinyin: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/pinyin/edit/save", vo, successCallback, failureCallback);
    },
    upload: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Pinyins");
        formData.append("field", "Audio");
        formData.append("uploadPath", Constants.FILE_STORAGE.TEMP_PATH + "dictionary/pinyin/");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
    //
    // wordArray: [ "朋友", "大家好", "你好" ]
    //
    generateAudio: (wordList, successCallback, failureCallback) => {
        ApiService.post("/common/chinese/generate/details", { wordList }, successCallback, failureCallback);
    }
};

export default EditService;
